module.exports = {"440608004":"荷城街道","440608106":"杨和镇","440608107":"明城镇","440608108":"更合镇","440608400":"高明监狱","440608401":"云勇林场","440608402":"对川茶场","440608403":"佛山监狱"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440608.json
// module id = 1989
// module chunks = 0